export default function UnicefBanner(
  uniSelector,
  ytSelector,
  videoTabSelector
) {
  const domain = "https://www.youtube.com";
  const player = document.querySelector(ytSelector);
  const banner = document.querySelector(uniSelector);
  const videoTab = document.querySelector(videoTabSelector);

  if (banner) {
    banner.onclick = () => {
      // PLay viedeo if player is active.
      if (player && videoTab?.ariaExpanded === "true") {
        player.contentWindow.postMessage(
          JSON.stringify({
            func: "seekTo",
            event: "command",
            args: [0, true],
          }),
          domain
        );

        player.contentWindow.postMessage(
          JSON.stringify({
            func: "playVideo",
            event: "command",
          }),
          domain
        );
      }

      // Hide banner.
      banner.remove();
    };
  }
}
